import { compose } from 'lodash/fp';
import image from '../../../../../page/screens/registerPage/onboarding-survey-step-two-highlight.png';
import authorImage from '../../../../../page/screens/registerPage/zapier-portrait.jpg';
import api from '../../../../api';
import Button from '../../../components/Button';
import { Form } from '../../../components/Form';
import { FormErrorMessage } from '../../../components/Form/FormErrorMessage';
import { FormGridRadio } from '../../../components/Form/FormInputs';
import { FormItem } from '../../../components/Form/FormItem';
import RegisterFlowTemplate from '../../../components/RegisterFlowTemplate';
import SaveButton from '../../../components/SaveButton';
import { withAppContext } from '../../../hoc/withAppContext';
import { withPageData } from '../../../hoc/withPageData';
import { goToOnboardingSurveyDone } from '../../../services/GoTo';
import styles from '../styles.m.less';

const BUTTON_LABELS = {
    DISABLED: 'Continue',
    ENABLED: 'Continue',
};

export type HrisIntegration = {
    category: string;
    className: string;
    enabled: boolean;
    icon: string;
    id: string;
    name: string;
    nameType: string;
    status: null | string;
    tooltip: null | string;
    url: string;
    visible: boolean;
};

function OnboardingSurveyHris({ adminLinks }: { adminLinks: any }) {
    const handleSubmit = async (formValue: any) => {
        if (formValue.hris) {
            return api.onboardingSettings
                .updateOnboardingSettings({ hris: formValue.hris.name })
                .then(goToOnboardingSurveyDone)
                .catch(goToOnboardingSurveyDone);
        }
    };

    const getIconImages = () => {
        let iconImagesArray = {};
        adminLinks.forEach((option: HrisIntegration) => {
            let icon;

            try {
                icon = require(`../../../features/Admin/Overview/svg/${option.icon}.svg`);
            } catch {
                icon = require(`../../../features/Admin/Overview/svg/default.svg`);
            }

            iconImagesArray = {
                ...iconImagesArray,
                [option.icon]: icon,
            };
        });

        return iconImagesArray;
    };

    return (
        <RegisterFlowTemplate
            step="5"
            imageURL={image}
            quote="“Small Improvements supports our remote working culture because it’s accessible from anywhere, intuitive to use, and easily adaptable to what we need.”"
            author="Jenny Bloom"
            role="Chief Financial Officer, Zapier"
            authorImage={authorImage}
            title="Integrate with your HRIS"
        >
            <Form<HrisIntegration> onSubmit={handleSubmit}>
                {({ submitError, invalid, pristine }) => {
                    return (
                        <>
                            <FormItem
                                name="hris"
                                label=""
                                inputComponent={FormGridRadio}
                                inputProps={{
                                    options: adminLinks,
                                    urlMapping: getIconImages(),
                                }}
                            />

                            <div className={styles.formButtonContainer}>
                                <SaveButton state="ENABLED" labels={BUTTON_LABELS} disabled={invalid || pristine} />
                                {submitError ? <FormErrorMessage errorMessage={submitError} /> : null}
                                <Button kind="LINK" onClick={() => handleSubmit({ hris: { name: 'other' } })}>
                                    My HRIS is not listed
                                </Button>
                            </div>
                        </>
                    );
                }}
            </Form>
        </RegisterFlowTemplate>
    );
}

export default compose(
    withPageData({
        resolve: {
            adminLinks: () =>
                api.admin
                    .getIntegrationsLinks()
                    .then(data => data.filter((option: any) => option.category.includes('Automated User Import'))),
        },
    }),
    withAppContext
)(OnboardingSurveyHris);
